(function collectionCallToAction(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const previouscollectionCallToAction = global.NewHomeSource.CollectionCallToAction;
  const languageResources = global.NewHomeSource.FullImageViewer.Config.languageResources;
  const messages = {};

  if (languageResources) {
    const translationKeys = Object.keys(languageResources);

    for (let i = 0; i < translationKeys.length; i += 1) {
      messages[translationKeys[i]] = languageResources[translationKeys[i]];
    }
  }

  /**
  * @constructs NewHomeSource.collectionCallToAction
  */
  function CollectionCallToAction() {

  }

  CollectionCallToAction.GetCollectionMessage = function getCollectionMessage(collectionName) {
    return messages[collectionName];
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.CollectionCallToAction to the previous script.
  */
  CollectionCallToAction.noConflict = function noConflict() {
    global.NewHomeSource.CollectionCallToAction = previouscollectionCallToAction;
    return CollectionCallToAction;
  };

  global.NewHomeSource.CollectionCallToAction = CollectionCallToAction;
}(window));
